export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_ROLE = "SET_ROLE";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_IS_LOGGED_IN = "SET_IS_LOGGED_IN";
export const SET_HOTEL = "SET_HOTEL";
export const SET_SELECTED_MODULE = "SET_SELECTED_MODULE";
export const SET_SELECTED_DATE = "SET_SELECTED_DATE";
